export default "__VITE_ASSET__DMVrSQok__"